<template>
  <ubi-panel>
    <el-row>
      <el-col :lg="24" style="text-align: center">
        <img
            alt=""
            src="@/assets/reviews_stats1.png"
            srcset="@/assets/reviews_stats1.png 2x"
            width="100"
        />

      </el-col>
<!--      <el-col :lg="8" style="text-align: center">-->
<!--        <img-->
<!--            alt=""-->
<!--            src="@/assets/reviews_stats2.png"-->
<!--            srcset="@/assets/reviews_stats2.png 2x"-->
<!--            width="100"-->
<!--        />-->
<!--      </el-col>-->
<!--      <el-col :lg="8" style="text-align: center">-->
<!--        <img-->
<!--            alt=""-->
<!--            src="@/assets/reviews_stats3.png"-->
<!--            srcset="@/assets/reviews_stats3.png 2x"-->
<!--            width="75"-->
<!--        />-->
<!--      </el-col>-->
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col :lg="24" style="text-align: center">{{ $t('socialReviews.stats.reviewCount') }}</el-col>
<!--      <el-col :lg="8" style="text-align: center">{{ $t('socialReviews.stats.unansweredReviewsCount') }}</el-col>-->
<!--      <el-col :lg="8" style="text-align: center">{{ $t('socialReviews.stats.averageRate') }}</el-col>-->
    </el-row>
    <el-row style="color: #0ab1bf; font-size: medium">
      <el-col :lg="24" style="text-align: center"><b>{{socialReviews.pagination.total}}</b></el-col>
<!--      <el-col :lg="8" style="text-align: center"><b>0</b></el-col>-->
<!--      <el-col :lg="8" style="text-align: center"><b>0/5</b></el-col>-->
    </el-row>
  </ubi-panel>
</template>
<script>
import UbiPanel from '@/components/Panel'
import { mapGetters, mapState } from 'vuex'
export default {
  components: { UbiPanel },
  computed: {
    ...mapState('socialReviewsList', ['filters', 'socialReviews', 'total']),
  },
  method: {
    ...mapGetters('socialReviewsList', ['filters', 'socialReviews', 'total'])
  }
}
</script>
